import React, { Suspense } from 'react';
import { SurveyJSLoadingSpinner } from '../../_lib/SurveyJS/partials/SurveyJSLoadingSpinner';

const FormApplicationBlock =
  React.lazy(() => import(/* webpackChunkName: "FormApplicationBlock" */ './FormApplicationBlock'));

/**
 * Lazy load the whole Form Application Block,
 * this will split any imports from survey into an own bundle and lazy load on demand.
 */
export function LazyLoadFormApplicationBlock(props: any) {
  return (
    <Suspense fallback={<SurveyJSLoadingSpinner />}>
      <FormApplicationBlock {...props} />
    </Suspense>
  );
}
